<template>
  <div class="wrap">
    <agreement :data="data"></agreement>
  </div>
</template>

<script>
import Agreement from '@/components/Agreement.vue';
import { userPrivacy } from '../../common/js/common';


export default {
  name: 'userPrivacy',
  components: {
    Agreement,
  },
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    this.data = userPrivacy;
  },
};
</script>
